export default class Swatches {
    constructor(options) {
        this.dom = {
            els: [...document.querySelectorAll(".product-swatch")]
        };

        this.collection_bar = options.collection_bar;
        this.assign();
        this.events();
    }

    assign() {
        this.dom.select_button = document.querySelector(
            ".samples-button:not(.modal-button)"
        );
        this.dom.add_collection = document.querySelector("#add-to-collection");
        this.dom.add_cart = document.querySelector("#add-to-cart");
    }

    toggle_select_button(el, toggle = false) {
        if (el) {
            if (toggle) {
                this.focus();

                el.innerHTML =
                    "Cancel swatch selection";
                el.classList.add("active");
            } else {
                this.collection_bar.discard();

                el.innerHTML =
                    "Select swatches";
                el.classList.remove("active");
            }
        }
    }

    _update_swatch_count() {
        const swatchCount = document.querySelector('.swatch-count')

        if (swatchCount) {
            if (document.querySelector('.js-interactive-panel')) {
                const l = [...document.querySelectorAll('[name="product-interactive"]:checked')].length
                swatchCount.innerHTML = `${l} ${l === 1 ? " swatch" : " swatches"}`;
            } else {
                const s = [...document.querySelectorAll(".selected")].length;
                swatchCount.innerHTML = `${s} ${s === 1 ? " swatch" : " swatches"}`;
            }
        }
    }

    _toggle_noswatches() {
        let s = [...document.querySelectorAll(".selected")];

        if (s.length === 0) {
            this.dom.add_collection.classList.add("noswatches");
            this.dom.add_cart.classList.add("noswatches");
            this.dom.add_collection.innerHTML =
                "<i class='fas fa-shopping-cart'></i> No swatches selected <span class='feature-tooltip'>To add samples to the sample cart, you must first select them by clicking on the swatches below.</span>";
            this.dom.add_cart.innerHTML =
                "<svg class='collection-icon'><use xlink:href='#collection-icon'></svg> No swatches selected <span class='feature-tooltip'>To add samples to the collection, you must first select them by clicking on the swatches below.</span>";
        } else {
            this.dom.add_collection.classList.remove("noswatches");
            this.dom.add_cart.classList.remove("noswatches");
            this.dom.add_collection.innerHTML = `<i class="fas fa-spinner fa-spin"></i>
    		<i class="fas fa-check"></i>
    		<svg class="collection-icon"><use xlink:href="#collection-icon"></svg> Add<span class="success-only">ed</span> to collection`;
            this.dom.add_cart.innerHTML = `<i class="fas fa-spinner fa-spin"></i>
        	<i class="fas fa-check"></i>
        	<i class="fas fa-shopping-cart"></i> Add<span class="success-only">ed</span> to sample cart`;
        }
    }

    events() {
        if (this.dom.select_button) {
            this.dom.select_button.addEventListener("click", e => {
                e.preventDefault();

                this._toggle_noswatches();

                if (this.dom.select_button.classList.contains("active")) {
                    this.collection_bar.discard();
                    this.collection_bar.close();              
                    document.body.classList.remove("select-mode-active");      

                    this.dom.select_button.classList.remove("active");
                    this.dom.select_button.innerHTML = "Select swatches";
                } else {
                    this.focus();
                    this.dom.select_button.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });

                    this.dom.select_button.classList.add("active");
                    this.dom.select_button.innerHTML =
                        "Cancel swatch selection";
                }
            });
        }

        this.dom.els.map(el => {
            let data = {
                id: el.getAttribute("data-product-id"),
                sku: el.getAttribute("data-product-sku"),
                quantity: 1
            };

            el.data = data;

        });

        this.collection_bar.bus.addEventListener("discard", () => {
            this.dom.els.map(el => {
                el.classList.remove("selected");
                this.collection_bar.close();
            });
        });
    }

    focus() {
        this.collection_bar.open();
        console.log("aopen");
        this.dom.els.map(el => {
            el.querySelector(".image-wrapper").classList.add("hover");
        });
    }

    unfocus() {
        this.dom.els.map(el => {
            el.querySelector(".image-wrapper").classList.remove("hover");
        });
    }

    toggle_sel(el) {
        let j = JSON.stringify(el.data);

        if (el.classList.contains("selected")) {
            if (window.stagedProducts.size === 1) {
                this.collection_bar.close();
                window.stagedProducts.delete(j);

                this.toggle_select_button(this.dom.select_button, false);
            }
        } else {
            this.collection_bar.open();
            window.stagedProducts.add(j);

            this.toggle_select_button(this.dom.select_button, true);
        }

        el.classList.toggle("selected");
        
        this._update_swatch_count();
        this._toggle_noswatches();
    }
}
